/**
 * The nine steps of the import workflow. `label` is the short name in the progress list; `title` is the plain-language
 * page heading (it receives focus when the step opens).
 */
export const WIZARD_STEP_DEFS = [
  { label: 'Choose source', title: 'Choose where your payroll history is from' },
  { label: 'Upload file', title: 'Upload your file' },
  { label: 'Check file', title: 'Check what we found' },
  { label: 'Match columns', title: 'Match your columns' },
  { label: 'Match employees', title: 'Match your employees' },
  { label: 'Review totals', title: 'Review your totals' },
  { label: 'Fix problems', title: 'Fix problems' },
  { label: 'Confirm', title: 'Confirm' },
  { label: 'Results', title: 'Results' },
] as const;

export const WIZARD_STEPS: string[] = WIZARD_STEP_DEFS.map((s) => s.label);

/** 0-based indexes of the steps (see {@link WIZARD_STEP_DEFS}). */
export const STEP_INDEX = {
  source: 0, upload: 1, found: 2, map: 3, employees: 4, totals: 5, problems: 6, confirm: 7, results: 8,
} as const;

export const NOT_NEEDED_NOTE = 'Not needed – your file already uses the EPN layout';
